<template>
  <div class="">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/icon-books.svg" width="50" alt="Minds" class="">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
      <h2 class="animation-top animation-delay-02">{{ 'VIRTUAL BOOKS' }}</h2>
        <hr class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Sua estante de livros é aqui. Use o código para desbloquear o conteúdo do book desejado. Bons estudos!</p>
        <button
          type="button"
          name="button"
          class="btn btn-md btn-rounded gradient-yellow btn-padding animation-bottom animation-delay-04 margin-top-10"
          @click="$router.push('/books')"
           v-if="!$store.getters['isReview']"
        >
          Books
        </button>
      </div>
    </div>
    <div class="relative">
      <div class="box-content shadow-box box-content-border">
        <bookList class="margin-bottom-10" :data="books" :add="add" />
      </div>
      <modal ref="modal" :show="showModal" bgcolor="rgba(54, 0, 0, .95)">
        <div class="btn-add-book animation-center center">
          <form class="btn-add-book form center animation-delay-1" @submit.prevent="addBook(bookCode)">
            <p class="animation-top animation-delay-02">Por favor insira o sua chave de licença para desbloquear o book desejado</p>
            <div class="btn-add-book--content__block_input container">
              <div class="flex-grow-1 box-input animation-center ">
                  <div class="input-space__modal container align-items-center" style="padding-left: 0px!important;">
                    <div class="key_text">KEY
                    </div>
                    <input type="text" placeholder="Código" class="input input-modal input-warningasdasd" v-model="bookCode" minlength="12" maxlength="15" required>
                    <div style="margin-right: 10px;">
                      <img src="@/assets/img/icons/check.svg" width="25" alt="Minds" class="">
                    </div>
                  </div>
              </div>
            </div>
            <div class="btn-add-book--content__block_btn">
              <button type="submit" class="btn btn-md btn-green gradient-green btn-full btn-rounded animation-bottom animation-delay-02" :disabled="verifying">
                Unlook Book
              </button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</template>

<script type="text/javascript">
  import bookList from '@/components/books'
  import modal from '@/components/modal'
  import modalBus from '@/components/modal/modalBus'

  export default {
    data () {
      return {
        books: [{
          id: 1,
          title: 'One',
          description: 'The beginning of a story. In this book you will learn the language you need to improve your English for basic communication.',
          page: 'book/one',
          class: 'gradient-books-one'
        }, {
          id: 2,
          title: 'Two',
          description: 'The story continues… In this book expand your comprehension of the English language.',
          page: 'book/two',
          class: 'gradient-books-two'
        }, {
          id: 3,
          title: 'Three',
          description: 'One more chapter in the story. This book will lead you to the next level of our course.',
          page: 'book/three',
          class: 'gradient-books-three'
        }, {
          id: 4,
          title: 'Four',
          description: 'One more chapter in the story. This book will lead you to the next level of our course.',
          page: 'book/four',
          class: 'gradient-books-four'
        }, {
          id: 5,
          title: 'Five',
          description: 'One more chapter in the story. This book will lead you to the next level of our course.',
          page: 'book/five',
          class: 'gradient-books-five'
        }],
        showModal: false,
        bookCode: '',
        verifying: false
      }
    },
    components: {
      bookList,
      modal
    },
    methods: {
      clonseModal () {
        this.showModal = false
      },
      async addBook (code) {
        try {
          this.$store.commit('setShowLoader', true)
          this.verifying = true
          await this.$store.dispatch('student/addVirtualBook', code)
          if (this.$store.getters['hasError']) throw Error('Failed to Add Book!')
          this.$refs['modal'].close()
        } catch (error) {
          alert(error)
        } finally {
          this.bookCode = ''
          this.verifying = false
          this.$store.commit('setShowLoader', false)
        }
      },
      add () {
        this.showModal = true
      }
    },
    beforeMount () {
      this.$store.dispatch('virtualBook/getBooks')
    },
    mounted () {
      modalBus.$on('close', this.clonseModal)
    },
    beforeDestroy () {
      modalBus.$off('close', this.clonseModal)
    }
  }
</script>

<style lang="scss">
  .btn-add-book {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
    padding: 40px;
    &.center { justify-content: center }
    &.form {
      width: 500px;
      height: 250px;
      background-color: rgb(234, 234, 234);
      border-radius: 15px;
    }

    &--content__block_btn {
      margin: 10px 0px 0px 0px;
      & button {
        height: 40px;
        width: 180px!important;
        text-transform: uppercase;
      }
    }
    & p{
    font-size: 20px;
    font-weight: 300;
    color: #1474BC;
    text-align: center;
    margin-bottom: 15px;
    }
 .input::-webkit-input-placeholder { /* Chrome, Safari, Opera */
  color: #525252;
  font-family: 'Volte', sans-serif;
  font-weight: 300;
  text-align: center;
  opacity: 1;
}

.input:-moz-placeholder { /* Firefox 18- */
  color: #525252;
  font-family: 'Volte', sans-serif;
  font-weight: 300;
  text-align: center;
  opacity: 1;
}

.input::-moz-placeholder {  /* Firefox 19+ */
  color: #525252;
  font-family: 'Volte', sans-serif;
  font-weight: 300;
  text-align: center;
  opacity: 1;
}

.input:-ms-input-placeholder { /* IE10+ */
  color: #525252;
  font-family: 'Volte', sans-serif;
  font-weight: 300;
  text-align: center;
  opacity: 1;
}
.key_text{
  width: 80px;
  display: flex;
  background: #8ED7E8;
  color: #278EA7;
  height: 40px;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}
.input-space__modal{
  background: #fff;
  border: 1px solid #ddd;
  padding-left: 15px;
  margin: 0;
  width: 100%;
  border-radius: 50px;
  overflow: hidden;
  transition: 0.3s;

  &:focus-within {
    box-shadow: 0px 0px 25px 5px #bfbfbf;
  }
  & .input-modal{
    text-align: center;
    font-family: 'Volte', sans-serif;
    font-weight: 300;
    color: #525252;
  }
}
  }
</style>



// WEBPACK FOOTER //
// src/pages/virtualBooks/books.vue